module.exports = __webpack_public_path__ + "img/delete_col.7a606854.svg";